"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedNavigation = void 0;
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../helpers");
const NestedNavigationItem_1 = require("./components/NestedNavigationItem/NestedNavigationItem");
const NestedNavigation_styles_1 = require("./NestedNavigation.styles");
const nestedNavigationDataSelectorId_1 = require("./helpers/nestedNavigationDataSelectorId");
exports.NestedNavigation = (0, helpers_1.createUIElement)('NestedNavigation', (_a, ref) => {
    var { className, items, style } = _a, rest = __rest(_a, ["className", "items", "style"]);
    return (react_1.default.createElement(NestedNavigation_styles_1.StyledNestedNavigation, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": rest['data-selector-id'] || nestedNavigationDataSelectorId_1.nestedNavigationDataSelectorId.main, className: (0, helpers_1.cn)('vm-NestedNavigation', className) }),
        react_1.default.createElement(NestedNavigation_styles_1.StyledNestedNavigationWrapper, { "data-selector-id": 'nested-navigation-wrapper' }, items.map(({ title, disabled, active, onClick, icon }, idx) => (react_1.default.createElement(NestedNavigationItem_1.NestedNavigationItem, { key: `nested-navigation-item-${idx}`, "data-selector-id": `${nestedNavigationDataSelectorId_1.nestedNavigationDataSelectorId.itemStringPartId}-${idx + 1}`, isDisabled: disabled, isActive: active, title: title, icon: icon, onClick: () => {
                if (!active && !disabled) {
                    onClick === null || onClick === void 0 ? void 0 : onClick();
                }
            } }))))));
});
//# sourceMappingURL=NestedNavigation.js.map